<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="client"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">

        <template #col-aging="{ row }">
            {{ row.aging }} Hrs.
        </template>
        <template #col-shipped="{ row }">
            {{ renderDate(row.shipped) }}
        </template>
        <template #col-pre_total="{ row }">
            {{ formatCurrency(row.pre_total, 'USD') }}
        </template>
        <template #col-total="{ row }">
            {{ formatCurrency(row.total, 'USD') }}
        </template>
        <template #col-approved="{ row }">
            <strong :class="row.approved == '1' ? 'custom-success' : 'custom-warning'">
                {{ row.approved == '1' ? 'Approved' : 'Pending' }}
            </strong>

        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView.vue'
import { formatCurrency, renderDate } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore', 'edit', 'delete','approve','file'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'client', label: 'client', sortable: true },
    { key: 'folio', label: 'folio', sortable: true },
    { key: 'entry_id', label: 'entry_id', sortable: true },
    { key: 'aging', label: 'aging', sortable: true },
    { key: 'shipped', label: 'shipped', sortable: false },
    { key: 'pre_total', label: 'pre_total', sortable: false },
    { key: 'total', label: 'total', sortable: true },
    { key: 'approved', label: 'status', sortable: true }

])

const actionButtons = ref([
    { text: 'approve', icon: 'CheckIcon', color: 'success', permissions: ['IU PREEXPENSES APPROVED'], hideIf: row => row.approved == '1', onClick: row => emit('approve', row) },
    { text: 'edit', icon: 'EditIcon', color: 'warning', permissions: ['IU PREEXPENSES EDIT'], hideIf: row => row.approved == '1', onClick: row => emit('edit', row) },
    { text: 'delete', icon: 'TrashIcon', color: 'danger', permissions: ['IU PREEXPENSES EDIT'], hideIf: row => row.approved == '1', onClick: row => emit('delete', row) },
    { text: 'files', icon: 'FileIcon', color: '#095BFF', permissions: ['IU PREEXPENSES VIEW'], hideIf: row => row.approved == '0', onClick: row => emit('file', row) }
])


</script>
